import { observer } from 'owa-mobx-react';
import type { IAnnouncedProps } from '@fluentui/react/lib/Announced';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Announced from '@fluentui/react', as this package has started migration to Fluent UI 9. Import useAnnounce from '@fluentui/react-components' instead. */
import { Announced as FabricAnnounced } from '@fluentui/react/lib/Announced';
import React from 'react';

// This component is responsible for rendering the Announced component for Narrator assistance
const Announced: React.FunctionComponent<IAnnouncedProps> = observer(function Announced(
    props: IAnnouncedProps
) {
    return <FabricAnnounced {...props} />;
}, 'Announced');

export default Announced;
